import { RootState } from '@/shared/types/state';

export const selectIsBannerOpen = (state: RootState) => state.banners.props !== null;

export const selectBanners = (state: RootState) => state.banners;
